import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  InputAdornment,
  Box,
  Skeleton,
  CircularProgress,
} from '@mui/material';
import { CopyAll as CopyAllIcon } from '@mui/icons-material';

const ShareDialog = ({
  open,
  shareData,
  shareLoading,
  onClose,
  onCopy,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Shareable Link {shareLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
      </DialogTitle>
      <DialogContent dividers>
        {shareLoading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Skeleton height={56} />
            <Skeleton height={56} />
          </Box>
        ) : (
          <>
            <TextField
              label="URL"
              value={shareData.url}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      size="small"
                      onClick={() => onCopy(shareData.url)}
                      startIcon={<CopyAllIcon />}
                    >
                      Copy
                    </Button>
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <TextField
              label="Password"
              value={shareData.password}
              fullWidth
              type="password"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      size="small"
                      onClick={() => onCopy(shareData.password)}
                      startIcon={<CopyAllIcon />}
                    >
                      Copy
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;